'use strict';

import afterHoursLeaderModule from './after-hours-leader';

const MODULE_NAME = 'daupler.entities.loveland';

var app = angular.module(MODULE_NAME, [
	afterHoursLeaderModule,
]);

export default MODULE_NAME;
